import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Response } from "../models/response";
import HttpClient from "../utils/network";
import { OnSiteApi } from "../apis/onsite";
import { CacheKey } from "../models/cacheKey";
import { TicketCheckInStatus } from "../models/enum/ticketCheckInStatus";
import { WinnerIdInfo } from "../models/winnerIdInfo";

export function useRegisterNoShow({
  artistId,
  eventId,
  rewardId,
}: {
  artistId: number;
  eventId: number;
  rewardId: number;
}) {
  const queryClient = useQueryClient();

  const { mutateAsync: registerNoShow, isPending } = useMutation({
    mutationFn: async (winnerIds: WinnerIdInfo[]) => {
      const response = new Response<void>(
        await HttpClient.request(
          OnSiteApi.registerNoShow(artistId, eventId, rewardId, winnerIds),
        ),
      );
      if (response.status < 300) {
        await queryClient.invalidateQueries({
          queryKey: [
            CacheKey.getCheckInUsers,
            eventId,
            TicketCheckInStatus.NOT_CHECKED_IN,
          ],
        });
      }
    },
  });

  return { registerNoShow, isPending };
}
